<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header v-if="!propsReadFromProps"/>

    <loading
        :active.sync="loadingMax"
        :is-full-page="true"
    ></loading>

    <b-row class="m-0">
      <b-col cols="6" lg="8" class="pr-0 pl-0">
        <div class="contenedorDistribucion mt-4" style="height: 700px;">
          <div class="d-flex justify-content-center">
            <div class="d-flex align-items-center justify-content-between pl-4 pr-4 box letterSizeSm ">
              <span> {{ datosPacienteBasico.nombreCompleto }} </span>
              <span  style="color: #65C045"> {{ datosPacienteBasico.motivoCita }}</span>
            </div>
          </div>

        <div class="mt-5">
          <p class="text-left" style="color: #0069A9; font-size: .85em; font-weight: 600;">Distribución de pago PTI</p>
          <div class="d-flex text-left mt-5">
            <em class="estrella_completa ml-0"/>
            <p class="text-left" style="color: #093974 !important;  font-size: .8em; font-weight: 500;">Tratamientos a pagar dentro de prioridad clinica</p>
          </div>
        </div>

      <div class="mt-2">
        <b-row class="text-center pl-3 pr-4" style="">
        <b-col cols="4" class=" text-left" :class="cardSeleccionado != null ? 'textoActivo' : 'thtable'" style="padding-left: 22px;">Concepto</b-col>
        <b-col class="thtable" :class="cardSeleccionado != null ? 'textoActivo' : 'thtable'">Inversión final</b-col>
        <b-col class="thtable" :class="cardSeleccionado != null ? 'textoActivo' : 'thtable'">Total pagado</b-col>
        <b-col class="thtable" :class="cardSeleccionado != null ? 'textoActivo' : 'thtable'">Total restante</b-col>
        <b-col class="thtable" :class="cardSeleccionado != null ? 'textoActivo' : 'thtable'">Saldo asignado</b-col>
        <b-col cols="1" class="thtable"></b-col>
      </b-row>
      <hr style="margin-top: 3px; border: 0; height: .1vh; background: #D6E7F3;">

      <div class="scrollable-container-di no-horizontal-scroll">
        <div v-for="(cp, index) in conceptoPlazo" :key="'datoConP-'+index">
          <b-card :class="cardSeleccionado === index ? 'cardSe seleccionado' : 'cardCerrada'" class="mt-2 mb-1"> <!--style="border: 1px solid #d6e7f3;"-->
            <b-row class="text-center">
              <b-col cols="4" :class="cardSeleccionado === index ? 'cardSeTitle seleccionado' : 'cardSeTitle'"
                     style=" width: 34.5%;"
                     class="text-left p-0 mt-lg-n2">
                <div class="d-flex " >
                  <em  class="iconPrecioFinanc" style="margin-top: -4%; padding-left: 2px"></em>
                  <p style="color: #3F9BD3; font-weight: 500; font-size: .8em; position: relative; margin-top: 5px;"> {{ cp.nombre }}</p>
                </div>
              </b-col>
              <b-col class="txtCuerpo">
                <p>{{ cp.inversionFinal | monedaDecimal }}</p>
              </b-col>
              <b-col class="txtCuerpo">
                <p>{{ cp.totalPagado | monedaDecimal }}</p>
              </b-col>
              <b-col class="txtCuerpo">
                <p>{{ cp.totalRestante | monedaDecimal }}</p>
              </b-col>
              <b-col class="txtCuerpo">
                <p>{{ cp.saldoAsignado | monedaDecimal }}</p>
              </b-col>
              <b-col cols="1" style="margin-top: -6px;">
                <div >

                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>


        <div v-for="(programado, index) in tratamientosProgramados" :key="'dato-'+index">
        <b-card :class="cardSeleccionado === index ? 'cardSe seleccionado' : 'cardCerrada'" class="mt-2 mb-1"> <!--style="border: 1px solid #d6e7f3;"-->
          <b-row class="text-center">
            <b-col cols="4" :class="cardSeleccionado === index ? 'cardSeTitle seleccionado' : 'cardSeTitle'"
                   style=" width: 34.5%;"
                   class="text-left p-0 mt-lg-n2">
             <div class="d-flex " >
              <em v-if="programado.idPresupuesto === 0" class="iconPrecioFinanc" style="margin-top: -4%; padding-left: 2px"></em>
              <em v-else-if="programado.idKitTratamiento === null" class="dienteCepillo" style="margin-top: -7%;"></em>
              <em v-else class="kit_svg" style="margin-top: -7%;"></em>

              <p v-if="programado.idPresupuesto === 0" style="color: #3F9BD3; font-weight: 500; font-size: .8em; position: relative; margin-top: 5px;"> {{ programado.tratamiento }}</p>
              <p v-else-if="programado.idKitTratamiento === null" :class="cardSeleccionado != null ? 'headerTxtActivo' : 'txtCuerpo'">{{ programado.tratamiento }}</p>
              <p v-else :class="cardSeleccionado != null ? 'headerTxtActivo' : 'txtCuerpo'">{{ programado.kitTratamiento }}</p>
             </div>
            </b-col>
            <b-col class="txtCuerpo">
              <p>{{ programado.inversionFinal | monedaEntero }}</p>
            </b-col>
            <b-col class="txtCuerpo">
              <p>{{ programado.saldoAsignado | monedaEntero }}<!--{{ programado.totalPagado | monedaEntero }}--></p>
            </b-col>
            <b-col class="txtCuerpo">
              <p>{{ programado.totalRestante | monedaEntero }}</p>
            </b-col>
            <b-col class="txtCuerpo">
              <p>{{ programado.saldoAsignado | monedaEntero }}</p>
            </b-col>
           <!--  <b-col class="txtCuerpo">
              <p>{{ programado.formasPago | monedaEntero }}</p>
            </b-col> -->
            <b-col cols="1" style="margin-top: -6px;">
              <div v-if="programado.idPresupuesto !== 0">
                <b-button v-if="cardSeleccionado === index" pill size="sm" variant="outline-ligth" class="p-0 tamanio-botones" @click="cardSeleccionado = null" :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'detalle-'+index" style="margin-top: -2%;">
                  <b-icon style="color: #4FB0B7;  font-size: 10px; height: 14px" class="tamanio-iconos" icon="chevron-up"></b-icon>
                </b-button>
                <b-button v-else pill size="sm" variant="outline-ligth" @click="cardSeleccionado = index" class="p-0 tamanio-botones" :id="'chevron-'+index" :key="'chevron-'+index" v-b-toggle="'detalle-'+index">
                  <b-icon style="color: #4FB0B7;  font-size: 10px; height: 14px" class="tamanio-iconos" icon="chevron-down"
                  ></b-icon>
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-collapse :id="'detalle-'+index" accordion="my-accordion-detalle" class="mt-1" role="tabpanel">
            <div class="p-3" style="border: 1px solid #F3F3F3; border-radius: 20px;">
              <div class="row text-center" style="max-height: 30px">
                <div class="col-2 d-flex justify-content-center align-items-center" style="border-right: 1px solid #DBDBDB; max-height: 30px">
                  <p class="mt-3 headerTxt">OD</p>
                </div>
                <div class="col ml-3 d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px"
                     v-if="programado.dientes.length > 0 && programado.dientes[0].idKitTratamiento !== null"
                >
                    <p class="mt-3 headerTxt">Tratamiento</p>
                </div>
                <div class="col ml-3 d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="mt-3 headerTxt">Cantidad</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="mt-3 headerTxt">Total</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="headerTxt">Total pagado</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="headerTxt">Total restante</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="headerTxt">Saldo asignado</p>
                </div>
                <div class="col d-flex justify-content-center align-items-center" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                    <p class="headerTxt">Forma de pago</p>
                </div>
                <div v-if="manual" class="col d-flex justify-content-center align-items-center mr-2" style="border-bottom: 1px solid #DBDBDB; max-height: 30px">
                  <p class="headerTxt">Cambio de saldo</p>
                </div>
              </div>


              <div class="" v-for="(diente, indexDiente) in programado.dientes" :key="'diente-'+indexDiente">
                <b-row class="text-center">
                  <b-col cols="2" class="pt-2 d-flex justify-content-center align-items-center" style="border-right: 1px solid #DBDBDB;">
                   
                    <div class="d-flex justify-content-center align-items-center pt-2 pb-2" style="border: 1px solid #B9D7EC; border-radius: 20px; max-height: 35px; min-width: 100%">
                        <p class="m-0 bodyTxt" style="font-weight: 600">{{ diente.diente }}</p>
                    </div>
                  </b-col>
                  <b-col v-if="diente.idKitTratamiento == null" class="d-flex justify-content-center align-items-center ml-3 mt-2">
                    <p class="m-0 bodyTxt">{{ diente.cantidad }}</p>
                  </b-col>
                  <b-col v-else class="d-flex justify-content-center align-items-center ml-3 mt-2">
                    <p class="m-0 bodyTxt">{{ diente.tratamiento }}</p>
                  </b-col>
                  <b-col v-if="diente.idKitTratamiento != null" class="d-flex justify-content-center align-items-center ml-3 mt-2">
                    <p class="m-0 bodyTxt">{{ diente.cantidad }}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center mt-2">
                    <p class="m-0 bodyTxt">{{ diente.inversionFinal | moneda}}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center mt-2">
                    <p class="m-0 bodyTxt">{{ diente.totalPagado  | moneda}}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center mt-2">
                    <p class="m-0 bodyTxt">{{ diente.totalRestante  | moneda}}</p>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center flex-column mt-2">
                    <div v-for="(listaFormas, indice) in diente.listaFormasPago" :key="'formasPago-'+indice">
                      <b-form-input
                        v-if="listaFormas.cambio"
                        class="redondeo"
                        style="font-size: .8em; width: 90px; height: 30px;"
                        type="number"
                        v-model.number="listaFormas.nuevoSaldo"
                        min="0"
                        step="1"
                        @keypress="onlyNumber"
                        @keydown="filterJustNumber($event)"
                        v-on:keyup="validarPrecioDistribuir(
                        listaFormas.nuevoSaldo,
                        listaFormas.formaPago.posicion,
                        index,
                        indexDiente,
                        indice)"
                      ></b-form-input>
                      <div v-else>
                        <div class="text-danger bodyTxt d-flex align-items-center" v-if="!diente.cumplido" style="min-height: 30px;">
                          {{listaFormas.nuevoSaldo | monedaSinDecimal}}
                        </div>
                        <div v-else class="bodyTxt d-flex align-items-center" style="min-height: 30px;">
                          {{listaFormas.nuevoSaldo | monedaSinDecimal}}
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col class="d-flex justify-content-center align-items-center flex-column mt-2 mr-2">
                    
                    <div v-for="(listaFormas, indice) in diente.listaFormasPago" :key="indice" style="min-height: 30px;">
                      <!-- {{ listaFormas }} -->
                     <!--  <b-form-select
                        v-if="manual"
                        class="redondeo"
                        style="font-size: .8em; width: 100px; height: 30px;"
                        v-model="listaFormas.formaPago"
                        :options="lstFormasPago"
                        text-field="formaPagoNombre"
                        value-field="idFormaPago"
                        :disabled="!listaFormas.cambio && listaFormas.formaPago !== null && listaFormas.formaPago.length !== 0"
                        @change="acumularSaldo(diente, indice)">
                      </b-form-select> -->
                     <div v-if="manual">
                            <v-select v-if="manual"
                            size="sm"
                            style="font-size: .6em; min-width: 118px;"
                              v-model="listaFormas.formaPago"
                              :options="lstFormasPago"
                              label="formaPagoNombre"
                              :disabled="!listaFormas.cambio && listaFormas.formaPago !== null && listaFormas.formaPago.length !== 0"
                              @input="acumularSaldo(diente, indice, programado)"
                              >
                            </v-select>
                      </div>
                      <label v-else>
                        {{listaFormas.formaPago.formaPagoNombre}}
                      </label>
                    </div>
                  </b-col>
                   <b-col v-if="manual" class="pt-2">
                    <div class="d-flex justify-content-center" v-for="(listaFormas, indice) in diente.listaFormasPago" :key="indice" style="margin-left: -20%; min-height: 30px;">
                      <b-button variant="outline-warning" pill class="mr-1 paddingbotones tamanio-botones" v-b-popover.hover.top="'Retirar / Abonar'" v-on:click="acumularSaldo(diente, indice, programado)">
                        <em class="editar_svg_amarillo icon-boton tamanio-iconos"></em>
                      </b-button>

                      <b-button :disabled="listaFormas.cambio" variant="outline-danger" pill class="mr-1 paddingbotones tamanio-botones" v-b-popover.hover.top="'Eliminar forma'" v-on:click="eliminarFormaPago(index, indexDiente, indice)">
                        <em class="eliminar_rojo_svg icon-boton tamanio-iconos"></em>
                      </b-button>

                      <b-button v-if="indice == 0" variant="outline-info" pill class="paddingbotones tamanio-botones" v-b-popover.hover.top="'Agregar forma'" v-on:click="agregarFormaPago(index, indexDiente)">
                        <em class="mas_azul_svg icon-boton tamanio-iconos"></em>
                      </b-button> 
                      

                      <!-- <b-button :disabled="listaFormas.cambio" size="sm" variant="outline-danger" class="m-2 paddingbotones2 marginbotones p-0 tamanio-botones" style="padding-left: 8px; padding-right: 8px" v-b-popover.hover.top="'Eliminar forma'" v-on:click="eliminarFormaPago(index, indexDiente, indice)">
                        <em class="m-0 eliminar sm"></em>
                      </b-button> -->

                      <!-- <b-button size="sm" variant="outline-info" pill class="m-2 paddingbotones2 p-0 tamanio-botones" v-b-popover.hover.top="'Agregar forma'" v-on:click="agregarFormaPago(index, indexDiente)">
                        <em class="mas_azul_svg"></em>
                      </b-button> -->
                    </div>
                    <div v-if="manual && diente.listaFormasPago.length == 0" class="mr-3">
                        <b-button variant="outline-info" pill class="m-1 paddingbotones tamanio-botones" v-b-popover.hover.top="'Agregar forma'" v-on:click="agregarFormaPago(index, indexDiente)">
                        <em class="mas_azul_svg icon-boton tamanio-iconos"></em>
                      </b-button> 
                      </div>
                   </b-col>
                </b-row>
              </div>
            </div>
          </b-collapse>
        </b-card>
        </div>
      </div>
      </div>
        </div>
      </b-col>

      <b-col cols="6" lg="4" class="pl-0">
        <b-card class="mt-4 letraTamanio9 contenedorDistribucion" style="">
            <p class="text-left" style="color: #0069A9 !important; font-weight: 600;">Formas de pago</p>
            <div style="min-height: 400px;">
              <div v-for="(pago, index) in lstFormasPago" :key="'pago-'+index" >
                <b-row>
                  <b-col>
                    <hr class="w-75">

                    <b-row>
                      <div>
                      <b-col class="text-left" v-if="pago.banderaTDC === 3">
                        <img :src="'data:image/png;base64,' + pago.imagen " :alt="pago.formaPagoNombre" style="position: relative; height: 22px; width: 74px;"/>
<!--                        <img v-if="pago.idFinanciera === 2" style="position: relative; height: 22px; width: 74px;" src="../../assets/version5/dentaliaPay.png" alt="Dentalia Pay"/>
                        <img v-if="pago.idFinanciera === 3" style="position: relative; height: 22px; width: 74px;" src="../../assets/version5/aPlazo.png" alt="aPlazo"/>
                        <img v-if="pago.idFinanciera === 4" style="position: relative; height: 36px; width: 86px;" src="../../assets/version5/kueskiPay.png" alt="Kueski Pay"/>-->
                        <div>
                          <span style=" font-size: .85em; ">{{ pago.formaPagoNombre }}</span>
                          <span style=" font-size: .85em; "> {{ pago.plazo }}</span>
                        </div>
                      </b-col>
                      <b-col class="text-left" v-else>
                        <em  class="tarjeta" style="margin-top: -4%; "></em>
                        <span style="color: #0069A9; font-size: .85em; font-weight: 500">{{ pago.formaPagoNombre }} {{ pago.plazo }}</span>
                        <div v-if="pago.banderaTDC === 2 || pago.banderaTDC === 1">
                          <span style=" font-size: .85em;">{{ pago.meses }} pagos mensuales de aprox {{pago.pagoMensual | monedaEntero}}</span>
                        </div>
                      </b-col>
                  </div>

                  <b-col class="text-right">
                    <span style="font-size: .85em" v-if="pago.banderaTDC === 3" > Monto a financiar: </span>
                    <span style="font-size: .85em" v-else-if="pago.banderaTDC === 2 || pago.banderaTDC === 1" > Total con cargos: </span>
                    <span style="font-size: .85em" v-else> Total: </span>
                    <span style="font-size: .85em; color: #3F9BD3; font-weight: 600" v-if="pago.banderaTDC === 0">  {{pago.montoPagar | monedaEntero}} </span>
                    <div v-if="pago.banderaTDC === 2 || pago.banderaTDC === 1 || pago.banderaTDC === 3">
                      <span style="font-size: .85em; color: #3F9BD3; font-weight: 600" v-if="pago.banderaTDC === 1">  {{pago.montoPagar |monedaDecimal }} </span>
                      <span v-else style="font-size: .85em; color: #3F9BD3; font-weight: 600">  {{pago.montoPagar | monedaEntero}} </span>
                    </div>
                  </b-col>

                </b-row>

                  </b-col>
                </b-row>
  <!--              <p>{{ pago.monto | monedaEntero }}</p>-->
              </div>
            </div>
          <br/>
            <hr class="w-75">

            <div class="mt-4">
              <div class="d-flex justify-content-between" v-if="conceptoPlazo.length >= 1">

                <p>Subtotal a pagar:</p>
                <p style="color: #1b81af;font-weight: 500">
                  {{ subtotalAPagar | monedaDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-if="conceptoPlazo.length >= 1" >
                <p>Costo de financiamiento + iva (16%):</p>
                <p style="color: #1b81af;font-weight: 500">
                  {{ costoFinanciamientoIva |monedaDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Inversión total:</p>
                <p style="color: #1b81af;font-weight: 500">
                  {{ inversionTotal | monedaDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between" v-if="conceptoPlazo.length >= 1" >
                <p>Inversión total restante:</p>
                <p style="color: #1b81af;font-weight: 500">
                  {{ inversionTotalRestante | monedaDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <p>Total pagado:</p>
                <p style="color: #1b81af; font-weight: 500">
                  {{ (totalPagado + costoFinanciamientoIva )| monedaDecimal }}
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <p style="font-weight: 600">Saldo por distribuir:</p>
                <p style="color: #1b81af; font-weight: 600">
                  {{ montos.totalDistribuir | monedaDecimal }}
                </p>
              </div>
            </div>
            <b-button class="mt-3" variant="primary" style="
                          border-radius: 10px;
                          background-color: #1b81af;
                          border: solid 1px #1b81af;
                        " @click="cerrarDistribucion"
                      :disabled="editando>0" v-if="!enviando && $localStorageService.can('UP_Inversion_PTI_firmar_pti')">
              Firmar PTI
            </b-button>
        </b-card>
      </b-col>
    </b-row>

  </div>

</template>

<script>

import Header from "@/components/Header.vue";

export default {
  name: "DistribucionPagoPTIv5",
  components: {Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    auxiliar: null,
    datosPacienteBasico: {
      idPaciente: null,
      nombreCompleto: null,
      motivoCita: null
    },
    cardSeleccionado: null,
    editando: 0,
    enviando: false,
    montos: {
      totalInversion: 0,
      totalInversionRestante: 0,
      totalPagado: 0,
      totalDistribuir: 0,
      totalAPagar: 0
    },
    manual: false,
    totalFormasPago: null,
    relacionPagos: [],
    grupo: 1,
    tratamientosProgramados: [],
    conceptoPlazo: [],
    lstFormasPago: [],
    subtotalAPagar: 0,
    costoFinanciamientoIva: 0,
    inversionTotal: 0,
    inversionTotalRestante: 0,
    totalPagado: 0,
    loadingMax: false,

    idPti: null,
    idSesion: null,
    idSolicitudEtapa:null,
    idSolicitud: null,
    idEtapa: null,
    opcion: null,

  }),
  props: {
    propsReadFromProps: {
      type: Boolean,
      default: false
    },
    propsIdPti: Number,
    propsIdSolicitud: Number,
    propsIdSolicitudEtapa: Number,
    propsIdEtapa: Number,
    propsOpcion: Number,
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    history.forward();

    if (this.propsReadFromProps) {
      this.idPti = this.propsIdPti;
      this.idSolicitudEtapa = this.propsIdSolicitudEtapa;
      this.idEtapa = this.propsIdEtapa;
      this.idSolicitud = this.propsIdSolicitud;
      this.opcion=this.propsOpcion;
    } else {
      this.idPti = this.$route.params.idPti;
      this.idSolicitudEtapa = this.$route.params.idSolicitudEtapa;
      this.idEtapa = this.$route.params.idEtapa;
      this.idSolicitud = this.$route.params.idSolicitud;
      this.opcion = this.$route.params.opcion;
    }

    this.obtenerDatosPacienteBasico();
    // this.traerDatosFormaPago();
    this.obtenerTratamientosDistribucion();
  },
  methods: {
    verDisponibilidad() {

      if (this.idSesion === null) {
        this.$swal({
          icon: "error",
          text: "El paciente debe contar con una sesión activa",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
          onClose: () => {
            this.redireccionar("Schedule");
          },
        });
      }else {

        this.$swal.fire({
          title: "¿Desea hacer distribución manual ó automática?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Manual",
          cancelButtonText: "Automatica",
          showLoaderOnConfirm: true,
          closeOnClickOutside: false,
          allowOutsideClick: false,
          preConfirm: () => {
            this.manual = true;
          }
        })
      }
    },
    redireccionar(ruta) {
      if (this.propsReadFromProps) {

        if (this.$route.name === 'cajaSesion') {
          this.$router.go(0);
        } else {
          this.$router.push({
            name: "cajaSesion",
            params: this.$route.params
          });
          location.reload();
        }

      } else {
        if (ruta != null) {
          this.$router.push({
            name: ruta
          }).catch((err) => {
            this.showErrorEnvio(err);
          });
        }
      }
    },
    acumularSaldo(programados, formaSeleccionada, programado) {
      let formaActual = programados.listaFormasPago[formaSeleccionada];
      if (
          formaActual.formaPago != null &&
          formaActual.nuevoSaldo > formaActual.formaPago.monto
      ) {
        this.$swal({
          icon: "warning",
          text: "El monto a pagar es menor al precio neto del tratamiento",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        formaActual.formaPago = null;
      }

      if (formaActual.formaPago != null) {
        if (
            this.validarAcumularSaldo(formaActual, programados) &&
            this.validarTotalSaldoAcumulado(programados)
        ) {
          //restamos precio y aumentamos saldo a favor
          formaActual.cambio = !formaActual.cambio;
          this.bloquearBtnFirmarPTI(formaActual.cambio);
          if (formaActual.cambio) {
            this.montos.totalDistribuir += formaActual.nuevoSaldo;
            this.montos.totalAPagar -= formaActual.nuevoSaldo;
            this.lstFormasPago.forEach((i) => {
              if (i.posicion == formaActual.formaPago.posicion) {
                i.saldoSobrante += formaActual.nuevoSaldo;
              }
            });
          } else {
            this.montos.totalDistribuir -= formaActual.nuevoSaldo;
            this.montos.totalAPagar += formaActual.nuevoSaldo;
            this.lstFormasPago.forEach((i) => {
              if (i.posicion == formaActual.formaPago.posicion) {
                i.saldoSobrante -= formaActual.nuevoSaldo;
              }
            });
          }

          programado.saldoAsignado = programado.dientes.reduce((total, d) => {
            return total + d.listaFormasPago.reduce((totald, ls) => {
              return totald + ls.nuevoSaldo;
            }, 0)
          }, 0);
        }
      }
    },
    validarAcumularSaldo(formaActual, programados) {
      let error = true;

      if (formaActual.formaPago.length === 0) {
        this.$swal({
          icon: "warning",
          text: "Seleccione una forma de pago",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = false;
      }

      if (formaActual.nuevoSaldo === "" || formaActual.nuevoSaldo < 0) {
        this.$swal({
          icon: "warning",
          text: "Debe colocar un número",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        error = false;
      }

      if (programados.inversionFinal < formaActual.nuevoSaldo) {
        this.$swal({
          icon: "warning",
          text: "El monto no puede ser mayor",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });

        error = false;
      }

      return error;
    },
    validarTotalSaldoAcumulado(programados) {
      let aceptado = true;
      let suma = 0;
      programados.listaFormasPago.forEach((i) => {
        suma += i.nuevoSaldo;
      });

      if (suma > programados.total) {
        aceptado = false;
        this.$swal({
          icon: "error",
          text: "La suma del saldo, no puede ser mayor al precio neto",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }

      return aceptado;
    },
    traerDatosFormaPago() {

      const parametros = {
        idPti: this.idPti,
        idSolicitud: this.idSolicitud,
        idEtapa: this.idEtapa
      }
      this.$http
          .post(this.$api + "forma/vista/activav5", parametros)
          .then((response) => {
            let totalFormas = 0;
            let montoPagarTotal = 0;
            response.data.data.forEach((i, j) => {
              i.saldoSobrante = i.monto;
              montoPagarTotal += i.monto;
              totalFormas++;
              i.posicion = j;
            });

            this.totalFormasPago = totalFormas;
            this.montos.totalDistribuir = montoPagarTotal;
            this.lstFormasPago = response.data.data;
            this.lstFormasPago.forEach((p) => {
              this.totalPagado += p.monto;
            })

            this.inversionTotalRestante = this.subtotalAPagar - this.totalPagado;
          //  this.inversionTotalRestante = this.inversionTotal - this.totalPagado;
          }).catch((err) => {
            console.error(err)
          }).finally(() => {
            this.asignarSaldoNormal();
          });
    },
    obtenerDatosPacienteBasico() {
      this.$http.post(this.$api + "paciente/obtenerDatosPacienteBasicoPorPti", this.traerParametrosPaciente()).then(respuesta => {
        if (respuesta.data.data) {
          this.datosPacienteBasico = respuesta.data.data;
          this.idSesion = respuesta.data.data.idSesion
        }
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        this.verDisponibilidad();
      })
    },
    traerParametrosPaciente() {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      return {
        idPti: this.idPti,
        idUsuario: this.$localStorageService.getIdUsuario(),
        horaInicio: inicio,
        horaFin: fin,
        presentacion: true,
        idClinica: this.$localStorageService.getIdClinica()
      };
    },
    obtenerTratamientosDistribucion() {
      const parametros = {
        idPti: this.idPti,
        idSolicitud: this.idSolicitud,
        idEtapa: this.idEtapa
      }
      this.$http.post(this.$api + "procesoPtiV5/obtener/opcion/tratamientos/distribucion", parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.tratamientosProgramados = respuesta.data.data.tratamientos;
          this.conceptoPlazo = respuesta.data.data.conceptoPlazo;
          this.tratamientosProgramados = this.tratamientosProgramados.map(obj => {
            return { ...obj, listaFormasPago: [] };
          })
          this.tratamientosProgramados.forEach(tp => {
            tp.dientes = tp.dientes.map(d => {
              return {...d, listaFormasPago: [], cumplido: true}
            })
          })
          this.inversionTotal = respuesta.data.data.inversionTotal;
          this.subtotalAPagar = respuesta.data.data.subtotalAPagar;
          this.costoFinanciamientoIva = respuesta.data.data.costoFinanciamientoIva;

          this.traerDatosFormaPago()
        }
      }).catch(error => {
        console.error(error);
      })
    },
    asignarSaldoNormal() {
      let contador = 0;
      /* this.complementos.forEach((it) => {
        contador = this.algoritmoAsignacionFormaPago(it, contador);
      });*/

      /*contador = 0;*/

      this.tratamientosProgramados.forEach((tp) => {
        tp.dientes.forEach(it => {
          contador = this.algoritmoAsignacionFormaPago(it, contador);
          tp.saldoAsignado += it.listaFormasPago.reduce((montos, objeto) => montos + objeto.nuevoSaldo, 0);
          tp.totalRestante += it.totalRestante;
        })
      });
    },
    algoritmoAsignacionFormaPago(it, i) {
      let procesoTerminado = true;
      let restanteTotalAsignado = 0;


      while (procesoTerminado) {
        if (this.lstFormasPago[i] !== undefined) {
          let formaPago = null;
          let nuevoSaldo = 0;


          formaPago = this.lstFormasPago[i];
          if (this.lstFormasPago[i].saldoSobrante >= it.totalRestante) {
            nuevoSaldo = it.totalRestante;
            this.lstFormasPago[i].saldoSobrante -= it.totalRestante;
          } else {
            it.cumplido = false;
            nuevoSaldo = this.lstFormasPago[i].saldoSobrante;
            this.lstFormasPago[i].saldoSobrante -= this.lstFormasPago[i].saldoSobrante;
            i++;
          }

          this.montos.totalDistribuir -= nuevoSaldo;
          this.montos.totalAPagar += nuevoSaldo;


          if (
              this.relacionPagos.length > 0 &&
              this.relacionPagos[this.relacionPagos.length - 1].pagoOriginal !=
              formaPago.monto
          ) {

            this.grupo++;
          }

          let pagos = {
            pagoOriginal: formaPago.monto,
            nuevoSaldo: nuevoSaldo,
            grupo: this.grupo,
          };

          it.listaFormasPago.push({
            formaPago: formaPago,
            nuevoSaldo: nuevoSaldo,
            cambio: false,
          });

          this.relacionPagos.push(pagos);

          restanteTotalAsignado = it.totalRestante - nuevoSaldo;

          if (restanteTotalAsignado == 0) {
            procesoTerminado = false;
          } else {
            it.totalRestante = restanteTotalAsignado;
          }
        } else {
          procesoTerminado = false;
        }
      }

      return i;
    },
    validarPrecioDistribuir(precio, indiceForma, index, indexDiente, indice) {
      let saldo = this.lstFormasPago[indiceForma].saldoSobrante;
      let restante = saldo - precio;
      restante = parseFloat(restante.toFixed(1));

      if (restante < 0) {
        this.tratamientosProgramados[index].dientes[indexDiente].listaFormasPago[
            indice
            ].nuevoSaldo = 0;
        this.$swal({
          icon: "warning",
          text: "No cuentas con saldo a distribuir con esta forma de pago",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        return false;
      }
    },
    agregarFormaPago(forma, indexDiente) {
      this.tratamientosProgramados[forma].dientes[indexDiente].listaFormasPago.push({
        nuevoSaldo: 0,
        formaPago: [],
        cambio: false,
      });

      this.$bvToast.toast('¡Recuerda colocar una forma de pago!', {
        title: 'Nueva forma de pago',
        variant: 'danger',
        solid: false
      })

      /* this.$swal({
        icon: "warning",
        text: "¡Recuerda colocarle una forma de pago!",
        showConfirmButton: false,
        timer: 1500,
      }); */
    },
    eliminarFormaPago(index, indexDiente, indice) {
      let vacio = false;
      let original = false;
      const valor = this.tratamientosProgramados[index].dientes[indexDiente].listaFormasPago[indice];

      if (valor.nuevoSaldo === "") {
        valor.nuevoSaldo = 0;
      }

      if (
          valor.formaPago === null ||
          (valor.formaPago.length == 0 && valor.nuevoSaldo != 0)
      ) {
        vacio = true;
      }

      if (
          valor.formaPago === null ||
          (valor.formaPago.length == 0 && valor.nuevoSaldo == 0)
      ) {
        original = true;
      }

      if (!vacio) {
        if (!original) {
          this.actualizarSaldo(valor.nuevoSaldo, valor.formaPago.posicion);
          this.tratamientosProgramados[index].saldoAsignado -= valor.nuevoSaldo;
        }
        this.tratamientosProgramados[index].dientes[indexDiente].listaFormasPago.splice(indice, 1);
      } else {
        this.$swal({
          icon: "error",
          text: "No debe seleccionar una forma de pago para acumular el saldo",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      }
    },
    actualizarSaldo(nuevoSaldo, indice) {
      this.montos.totalDistribuir += nuevoSaldo;
      this.montos.totalAPagar -= nuevoSaldo;
      this.lstFormasPago[indice].saldoSobrante += nuevoSaldo;
    },
    seleccionarCard(index) {
      this.cardSeleccionado = index;
    },
    deseleccionarCard() {
      this.cardSeleccionado = null;
    },
    cerrarDistribucion() {
      if (this.montos.totalDistribuir.toFixed(0) > 0) {
        this.$swal({
          icon: "error",
          text: "El saldo a distribuir debe quedar en 0",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {


        let contadorTrstSinSaldo = 0;
        this.tratamientosProgramados.forEach(tp => {
          if (tp.saldoAsignado == 0){
            contadorTrstSinSaldo ++;
          }
        })

        if (contadorTrstSinSaldo > 0){
          this.$swal({
            icon: 'warning',
            width: '45em',
            html: '<strong><p style="font-size: 1.2em; margin-bottom: 0">Tratamientos sin saldo a favor</p></strong> <br>' +
                '<p style="margin-bottom: 0">Hay tratamientos a los que no se les asignó saldo a favor, estos tratamientos no se pagarán pero si se programarán.</p>' +
                '<p style="margin-bottom: 0">Los precios estarán sujetos a vigencia,</p> <p>¿desea continuar?</p>',
            showCloseButton: false,
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Sí',
            confirmButtonColor: '#eeba6d',
            cancelButtonText: 'No',
            cancelButtonColor: '#ffffff',
            customClass: {
              confirmButton: 'pl-5 pr-5 mr-1 mr-sm-5 rounded-pill',
              cancelButton: 'pl-5 pr-5 ml-1 ml-sm-5 rounded-pill border border-secondary text-secondary'
            },
          }).then((aceptar) => {
            if (aceptar.value) {
              // alert("Confirmo")
              this.enviarDatos();
            }
          });
        } else {
          this.enviarDatos();
        }



      }
    },

    enviarDatos(){
      this.loadingMax = true;

      this.$http.post(this.$api + "procesoPtiV5/guardar/tratamientos/distribucion", this.traerDatos())
          .then(response => {
            if (response.data.data){
              if (this.idEtapa === 99) {
                this.$router.push({
                  name: "impresionPtiv5",
                  params: {
                    idPti: this.idPti,
                    idSolicitudEtapa: this.idSolicitudEtapa,
                    idSolicitud: this.idSolicitud,
                    idEtapa: 100,
                    opcion: this.opcion,
                    propsReadFromProps: this.propsReadFromProps
                  }})
              } else {
                this.$router.push({
                  name: "impresionPtiv5",
                  params: {
                    idPti: this.idPti,
                    idSolicitudEtapa: this.idSolicitudEtapa,
                    idSolicitud: this.idSolicitud,
                    idEtapa: this.idEtapa,
                    opcion: this.opcion,
                    propsReadFromProps: this.propsReadFromProps
                  }})
              }
            }
          }).finally(() => {
            this.loadingMax = false;
          })


    },

    traerDatos() {
      let index = 0;
      let grupo = 1;
      let sumaPago = 0;
      let envioTxProgramados = JSON.parse(JSON.stringify(this.tratamientosProgramados))

      envioTxProgramados.forEach((programados) => {
        programados.dientes.forEach(d => {
          let formasPagoLista = [];
          if (d.listaFormasPago.length !== 0) {
            let grupoAsignar;
            sumaPago += d.listaFormasPago.nuevoSaldo;

            if (sumaPago > d.listaFormasPago[0].formaPago.montoPagar) {
              sumaPago = 0;
              grupo ++;
            }

            if (this.relacionPagos[index] !== undefined ) {
              grupoAsignar = this.relacionPagos[index].grupo;
            }else{
              grupoAsignar = grupo;
            }

            let indx = 0;
            let tieneOtroPago = false;
            d.listaFormasPago.forEach((i) => {
              if(indx>0 && d.listaFormasPago[indx].formaPago.idFormaPago !== d.listaFormasPago[indx-1].formaPago.idFormaPago){
                tieneOtroPago = true;
              }
              console.log( ">>>>>>>>>>>>>>> iii ", i)
              let lista = {
                idFormaPago: i.formaPago.idFormaPago,
                idFormaDetalle: i.formaPago.idFormaDetalle,
                idFormaPagoTemporal: i.formaPago.idFormaPagoTemporal,
                monto: d.total,
                montoPagar: i.nuevoSaldo,
                posicion: i.formaPago.posicion,
                idFinanciera: i.formaPago.idFinanciera,
                plazo: i.formaPago.plazoNum,
                grupoPago: tieneOtroPago ? grupoAsignar+1 : grupoAsignar,
                tipoDistribucion: this.manual ? 2 : 1
              };
              tieneOtroPago = false;
              indx++;
              index++;
              formasPagoLista.push(lista);
            });

            d.listaFormasPago = formasPagoLista;
          }else{//Se agrega una forma de efectivo 0 a los trts que no se les alcanzo la distribucion
            let idGrupoPago = 0;
            envioTxProgramados.forEach(programados => {
              programados.dientes.forEach(item=>{
                item.listaFormasPago.forEach(forma=>{
                  if(forma.idFormaPago == 1 && forma.grupoPago != undefined){
                    idGrupoPago = forma.grupoPago;
                  }
                })
              })
            });
            console.log(" lista del else", lista)
            let lista = {
              idFormaPago: 1,
              montoPagar: 0,
              grupoPago: idGrupoPago != 0 ? idGrupoPago : this.grupo+1,
              tipoDistribucion: this.manual ? 2 : 1
            };
            formasPagoLista.push(lista);
            d.listaFormasPago = formasPagoLista;
          }
        })
      });

      return  {
        idPti: this.idPti,
        idSolicitudEtapa: this.idSolicitudEtapa,
        idSolicitud: this.idSolicitud,
        idClinica: this.$localStorageService.getIdClinica(),
        tipoDistribucion: this.manual ? 2 : 1,
        idSesion: this.idSesion,
        tratamientos: envioTxProgramados,
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    filterJustNumber(e) {
      const key = e.key;

      // If is '.' key, stop it
      if (key === ".") return e.preventDefault();

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === "e") return e.preventDefault();
    },
    bloquearBtnFirmarPTI(cambio){
      if(cambio) this.editando++
      else this.editando--
    },
  }
}
</script>

<style scoped>
.letterSizeSm{
  font-size: .75em;
  font-weight: 600;
}

.contenedorDistribucion {
  border:1px solid  #E0E0E0;
  border-radius: 1rem;
  width: 99%;
  min-height: 800px;
  background-color: #fff;
  padding-left: 2%;
  padding-right: 2%;
  padding-top: 0px;
 /* overflow: scroll;*/
}

.textoActivo{
  font-size: .6em !important;
  font-weight: bolder;
  color: #BFBFBF;
}

.headerTxtActivo{
  font-size: .6em !important;
  font-weight: bolder;
  color: #4f4f4f;
}

.txtCuerpo{
  font-size: .8em !important;
  color: #4F4F4F;
}

.headerTxt{
  font-size: .8em;
  color: #4F4F4F;
  font-weight: 600;
}
.bodyTxt{
  font-size: .8em;
  color: #747474;
}

.thtable {
  font-size: .7em !important;
  font-weight: bolder;
}

.cardSe {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  min-height: 60px;
}

.cardCerrada {
  border: 1px solid #d6e7f3;
  border-radius: 16px;
  height: 60px;
}

.texto-gris {
  color: #999797 !important;
}

.texto-gris-oscuro {
  color: #4F4F4F !important;
}

.cardSe.seleccionado {
  border-style: solid;
  border-width: 2px;
  border-color: #90d3dd;
  border-radius: 16px;
  /* color: #17a2b8;*/
}

.titulo-seleccionado {
  color: #4F4F4F !important;
  font-weight: 600;
}

.border-bottom-gris {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.tamanio-botones {
  width: 20px;
  height: 20px;
}

.letraTamanio7 {
  font-size: 0.75em !important;
}

.letraTamanio9 {
  font-size: 0.9em !important;
}

.tamanio-iconos {
  width: 9px;
  height: 9px;
}

.box {
  top: 0px;
  width: 60%;
  background: #ffffff;
  border-radius: 20px;
  height: 6vh;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
}
.scrollable-container-di {
  overflow-y: auto;
  min-height: 44vh;
  max-height: 44vh;
}
</style>